// Central, reusable company data. Keep marketing content here so the site
// stays scalable and a CMS/admin can replace this source later without UI changes.

export const company = {
  name: "Envago Labs",
  legalName: "Envago Labs",
  tagline: "Creating AI-powered apps that educate, inspire and simplify everyday life.",
  heroHeadline: "Building AI-powered apps that make learning smarter.",
  intro:
    "Envago Labs develops intelligent mobile applications focused on education, productivity and everyday life. We combine thoughtful design with modern AI to build tools people genuinely rely on.",
  website: "https://envagolabs.com",
  emails: {
    company: "support@envagolabs.com",
    tanzeen: "support@tanzeenplus.com",
  },
  mission:
    "To build meaningful, AI-powered software that makes learning and daily life simpler, smarter and more accessible for everyone.",
  values: [
    {
      title: "Purposeful Technology",
      description:
        "We build products that solve real problems and add lasting value, not features for the sake of features.",
      icon: "Target",
    },
    {
      title: "Trust & Privacy",
      description:
        "User trust comes first. We design with privacy, transparency and data responsibility at the core.",
      icon: "ShieldCheck",
    },
    {
      title: "Craft & Quality",
      description:
        "Every detail matters. We hold our software to a high standard of design, performance and reliability.",
      icon: "Gem",
    },
    {
      title: "Human-Centered AI",
      description:
        "AI should assist and empower people. We build intelligent tools that stay clear, helpful and honest.",
      icon: "Sparkles",
    },
  ],
  stats: [
    { label: "Apps in development", value: "1+", note: "and growing" },
    { label: "Core focus areas", value: "3", note: "education · productivity · daily life" },
    { label: "Platforms targeted", value: "iOS + Android", note: "cross-platform" },
    { label: "Founded", value: "2025", note: "independent AI studio" },
  ],
  whyChoose: [
    {
      title: "AI at the core",
      description:
        "Our applications are built around modern AI to deliver genuinely helpful, adaptive experiences.",
      icon: "BrainCircuit",
    },
    {
      title: "Design that respects you",
      description:
        "Clean, distraction-free interfaces that put your goals first without dark patterns.",
      icon: "LayoutTemplate",
    },
    {
      title: "Built to scale",
      description:
        "A growing family of apps under one trusted studio, each crafted with the same standard of quality.",
      icon: "Layers",
    },
    {
      title: "Support you can reach",
      description:
        "Real support channels, clear documentation and a team that listens to feedback.",
      icon: "LifeBuoy",
    },
  ],
};

export const navLinks = [
  { label: "Home", to: "/" },
  { label: "Products", to: "/products" },
  { label: "About", to: "/about" },
  { label: "Support", to: "/support" },
  { label: "Contact", to: "/contact" },
];

export const footerLinks = [
  { label: "Home", to: "/" },
  { label: "Products", to: "/products" },
  { label: "About", to: "/about" },
  { label: "Support", to: "/support" },
  { label: "Privacy", to: "/privacy" },
  { label: "Terms", to: "/terms" },
  { label: "Contact", to: "/contact" },
];
